"use strict";import{IconInfo as o}from"../src/elements/IconInfo.js";import{defineElement as n}from"@spectrum-web-components/base/src/define-element.js";n("sp-icon-info",o);
//# sourceMappingURL=sp-icon-info.js.map
